import { readQueue } from "./modules/invoker";
import { Scribe } from "./modules/scribe";

let scribe = Scribe();

if (window.scribesdk && window.scribesdk.q) {
  readQueue(scribe, window.scribesdk.q);
}

window.scribesdk = scribe;

export default scribe;
